import { FormattedMessage } from 'react-intl';
import NextImage from 'src/shared-components/NextImage/NextImage';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import dynamic from 'next/dynamic';
import Skeleton from 'react-loading-skeleton';
import { delayWrapper } from 'src/utils/delayWrapper';
import trns from '../trns';

const NavigationLink = dynamic(
  () =>
    delayWrapper<typeof NavigationLink>(
      import('src/shared-components/NavigationLink/NavigationLink')
    ),
  {
    loading: () => <Skeleton width={'100%'} height={32} />
  }
);

const checkedCheckmarkBlue = 'shared/checkbox-checked-checkmark.svg';

export const DrugInCartComponent = () => {
  const { trackGtagEvent } = useGTAG();
  return (
    <NavigationLink
      href="/checkout/cart"
      shallow
      onClick={() => {
        trackGtagEvent(`${GTAGPrefix.item}_added`);
      }}
    >
      <div className="flex items-center">
        <NextImage
          alt={'checked checkmark icon'}
          src={checkedCheckmarkBlue}
          layout="fixed"
          height={18}
          width={18}
        />
        <p className="pl-[11px] fs-body-lg-reg text-astronautBlue">
          <FormattedMessage {...trns.inListLabel} />
        </p>
      </div>
    </NavigationLink>
  );
};
